module.exports = __webpack_public_path__ + "static/media/500-question.a56caf21.svg";